import React, { useState } from 'react';
import { useAdminAuth } from '../../hooks/useAdminAuth';
import { signInWithGoogle, signOutUser } from '../../utils/adminAuth';

const getSignInErrorMessage = (error) => {
  switch (error?.code) {
    case 'auth/unauthorized-domain':
      return 'Ez a webcím nincs engedélyezve a Firebase Auth beállításaiban.';
    case 'auth/popup-blocked':
      return 'A böngésző blokkolta a bejelentkezési ablakot. Engedélyezd a felugró ablakokat, majd próbáld újra.';
    case 'auth/popup-closed-by-user':
      return 'A bejelentkezési ablak bezárult a folyamat befejezése előtt.';
    case 'auth/network-request-failed':
      return 'Hálózati hiba történt. Ellenőrizd az internetkapcsolatot, majd próbáld újra.';
    case 'auth/operation-not-allowed':
      return 'A Google-bejelentkezés nincs engedélyezve a Firebase Auth beállításaiban.';
    default:
      return 'Nem sikerült a bejelentkezés. Próbáld újra, vagy ellenőrizd a Firebase Auth beállításait.';
  }
};

export function AdminLoginCard({ description }) {
  const { loading, isAuthenticated, isAdmin, authUser } = useAdminAuth();
  const [error, setError] = useState('');

  const handleSignIn = async () => {
    setError('');
    try {
      await signInWithGoogle();
    } catch (signInError) {
      console.error('Admin sign-in failed:', signInError?.code || signInError);
      setError(getSignInErrorMessage(signInError));
    }
  };

  const handleSignOut = async () => {
    setError('');
    try {
      await signOutUser();
    } catch {
      setError('Nem sikerült kijelentkezni.');
    }
  };

  if (loading) {
    return (
      <div className="rounded-3xl border border-[#0F3D2C] p-8 md:p-10 max-w-2xl bg-card/60">
        <p className="text-sm text-muted-foreground">Jogosultság ellenőrzése...</p>
      </div>
    );
  }

  if (isAuthenticated && !isAdmin) {
    return (
      <div className="rounded-3xl border border-destructive/40 p-8 md:p-10 max-w-2xl bg-card/60">
        <p className="text-sm font-medium text-destructive">Nem jogosult a bejelentkezésre.</p>
        <p className="mt-2 text-xs text-muted-foreground break-words">
          UID: {authUser?.uid || 'ismeretlen'}
        </p>
        <button onClick={handleSignOut} className="btn-secondary text-sm mt-4">
          Kijelentkezés
        </button>
        {error && <p className="mt-4 text-sm text-destructive">{error}</p>}
      </div>
    );
  }

  return (
    <div className="rounded-3xl border border-[#0F3D2C] p-8 md:p-10 max-w-2xl bg-card/60">
      <p className="text-sm text-muted-foreground">
        {description || 'Jelentkezz be Google fiókkal az admin felülethez.'}
      </p>
      <button onClick={handleSignIn} className="btn-primary text-sm mt-4">
        Bejelentkezés Google-lel
      </button>
      {error && <p className="mt-4 text-sm text-destructive">{error}</p>}
    </div>
  );
}
